import { render, staticRenderFns } from "./AreaRegions.vue?vue&type=template&id=1ef480b2&"
import script from "./AreaRegions.vue?vue&type=script&lang=js&"
export * from "./AreaRegions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports